import { render, staticRenderFns } from "./InboxDummy.vue?vue&type=template&id=c517c56c&scoped=true"
import script from "./InboxDummy.vue?vue&type=script&lang=js"
export * from "./InboxDummy.vue?vue&type=script&lang=js"
import style0 from "./InboxDummy.vue?vue&type=style&index=0&id=c517c56c&prod&scoped=true&lang=css"
import style1 from "./InboxDummy.vue?vue&type=style&index=1&id=c517c56c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c517c56c",
  null
  
)

export default component.exports